module.exports = __webpack_public_path__ + "img/oth10.1469cf95.png";